import * as Yup from 'yup';

export const getResponsibleValidationShape = () => ({
  responsible: Yup.string().when('$hasExistingUsers', {
    is: true,
    then: (schema) => schema,
    otherwise: (schema) => schema.required('Este campo é obrigatório!'),
  }),
  email: Yup.string()
    .email('Email inválido')
    .when('$hasExistingUsers', {
      is: true,
      then: (schema) => schema,
      otherwise: (schema) => schema.required('Este campo é obrigatório!'),
    }),
  responsible_phone: Yup.string().when('$hasExistingUsers', {
    is: true,
    then: (schema) => schema,
    otherwise: (schema) => schema.required('Este campo é obrigatório!'),
  }),
  function: Yup.string().when('$hasExistingUsers', {
    is: true,
    then: (schema) => schema,
    otherwise: (schema) => schema.required('Este campo é obrigatório!'),
  }),
});
